import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    background: ({ color }) => color,
    margin: 'auto',
    display: 'flex'
  },

  type: ({ typeVariant, dark }) => ({
    ...(!typeVariant && theme.typography.largebody),
    margin: 'auto',
    textTransform: 'uppercase',
    color: dark ? 'white' : 'black'
  })
}), { name: 'MuiGlueAcronymIcon' })

// These are the 500 colors from the common palette
const lightColors = [
  '#54b5ff',
  '#a375ff',
  '#d9363b',
  '#09b363',
  '#e6b837',
  '#e9551c'
]

// These are the 900 colors from the common palette
const darkColors = [
  '#004880',
  '#402578',
  '#4a0c11',
  '#00542e',
  '#594304'
]

const AcronymIcon = (props) => {
  const stringToIntHash = (str) => {
    if (!str || typeof str !== 'string') {
      return 0
    }

    let result = 0
    for (let i = 0; i < str.length; i++) {
      result += str.charCodeAt(i)
    }

    return result
  }

  const getAcronym = (name) => {
    if (!name || typeof name !== 'string') {
      return ''
    }

    let acronym = name.split(/\s/).reduce((response, word) => { response += word.slice(0, 1); return response }, '')
    acronym = acronym.substring(0, 2)

    if (acronym.length < 2) {
      acronym = name.slice(0, 2)
    }

    return acronym
  }

  const intHash = stringToIntHash(props.id)
  const colorFromHash = props.dark ? darkColors[intHash % darkColors.length] : lightColors[intHash % lightColors.length]
  const acronym = getAcronym(props.text)

  const classes = useStyles({ ...props, color: colorFromHash })

  return (
    <div className={classes.root}>
      <Typography variant={props.typeVariant} classes=>{acronym}</Typography>
    </div>
  )
}

export default AcronymIcon
